var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5V10.5M5.58534 2.56577C6.55456 1.89377 7.73129 1.5 9 1.5C12.3137 1.5 15 4.18629 15 7.5V8.4275M3.31224 5.58455C3.10975 6.18607 3 6.83022 3 7.5V10.5C3 13.2261 4.81812 15.5276 7.30797 16.2581M14.7441 12.239C14.197 14.0485 12.8183 15.4969 11.0526 16.1397M10.7437 4.60976C10.2348 4.30207 9.63808 4.125 9 4.125C7.13604 4.125 5.625 5.63604 5.625 7.5V9.7125M12.375 8.28V10.5C12.375 12.364 10.864 13.875 9 13.875C8.36351 13.875 7.76818 13.6988 7.2601 13.3925",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureInactive);
export default __webpack_public_path__ + "static/media/secure-inactive.e0784bd01f55e5f2970960dcf0c871e2.svg";
export { ForwardRef as ReactComponent };